import React, { useEffect, useState } from 'react';
import './../Styles/LandingPage.css';
import {useNavigate} from 'react-router-dom';
import { ReactComponent as OhMyFoodLogoWithTitle } from '../assets/svg/ohMyFoodLogoWithTitle.svg';
import { useAuth } from '../AuthProvider';
import { Helmet } from 'react-helmet';
import { CONSTANT, SEO } from '../Utils/Constant';

function LandingPage() {
    const { userID ,userRole} = useAuth();
    const [selectedRole, setSelectedRole] = useState('vendor');
    const navigate = useNavigate();

    useEffect(() => {
        if (userID) {
            if (userRole === 'vendor') {
                navigate('/home');
            } else {
                navigate('/dashboard');
            }
        }
    }, [userID, userRole, navigate]);
        

    const handleLogin = () => {
        navigate('/login');
    };
    const handleSignup = () =>{
        navigate('/signup');
    };
    const handlePartner = () =>{
        setSelectedRole('vendor');
        navigate('/signup', {state: {role: selectedRole}});
    };
    const handleSkip = () =>{
        localStorage.removeItem('authToken');
        localStorage.removeItem('accountID');
        localStorage.removeItem('signupEmail'); 
        navigate('/reels');
    };

    return (
        <div className='landing-page-container'>

            <Helmet>
                <title>{SEO.LANDING_PAGE.TITLE}</title>
                <meta name="description" content={SEO.LANDING_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.LANDING_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.LANDING_PAGE.CANONICAL} />

                {/* Open Graph */}
                <meta property="og:title" content={SEO.LANDING_PAGE.TITLE} />
                <meta property="og:description" content={SEO.LANDING_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.LANDING_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.LANDING_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.LANDING_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
            
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.LANDING_PAGE.TITLE} />
                <meta name="twitter:description" content={SEO.LANDING_PAGE.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
            
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'WebPage',
                        name: `${CONSTANT.OMYFOOD} - See the Flavor. Crave the Taste. Delivered Fast`,
                        url: `${CONSTANT.OMYFOOD_WEB_LINK}`,
                        description: `${CONSTANT.OMYFOOD} is your go-to platform for online food delivery, offering a wide range of cuisines with fast, reliable service.`,
                        publisher: {
                            '@type': 'Organization',
                            name: CONSTANT.OMYFOOD,
                            url: CONSTANT.OMYFOOD_WEB_LINK,
                            logo: {
                                '@type': 'ImageObject',
                                url: 'https://omyfood.io/OMF_logo_bg.png'
                            }
                        },
                        potentialAction: {
                            '@type': 'ViewAction',
                            target: `${CONSTANT.OMYFOOD_WEB_LINK}/reels`,
                            name: 'Watch Food Reels',
                            description: 'Explore food reels and discover your cravings in seconds.'
                        }
                    }, null, 2)}
                </script>
    
            </Helmet>

            <div className='landingpage-overlay'></div>
            <div>

                <div className='omf-logo-title-container'>
                    <div className="omf-logo-title">
                        <OhMyFoodLogoWithTitle className="omf-logo-title" />
                    </div>

                    <h1 style={{display: 'none'}}></h1>
                    <h2 style={{display: 'none'}}></h2>
                    <h3 style={{display: 'none'}}></h3>

                    <h4 className='landing-page-quote'>“At OMF, we deliver cravings the moment they spark — one glance, one crave, one tap.”</h4>


                    <button className='landing-page-login-btn' onClick={handleLogin}>Login</button>
                    <button className='landing-page-signup-btn' onClick={handleSignup}>Sign Up</button>
                    <button className='landing-page-partner-btn' onClick={handlePartner}>Partner with us</button>


                    <div className='skip-container' onClick={handleSkip}>
                        <p className='skip-text'>Skip</p>
                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.04284 14L15.5745 7.5L9.04118 1M1.57617 7.5H15.5762H1.57617Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>

                </div>
            </div>


        </div>
    );
}

export default LandingPage;